import { connect } from 'react-redux'

import {
  getNotificationsList,
  getUserPermissions,
  markNotificationReadApi,
  signOut,
} from 'modules/Auth/actions'
import selector1 from 'modules/Auth/selectors'
import selector from 'modules/Onboarding/selectors'
import Page from 'modules/Page/Components/index'
import { getEventsList, registerEvent } from '../../Events/actions'
import { updateStudent } from '../../Resume/actions'
import { ApplyRole } from '../../Roles/actions'
const mapStateToProps = state => ({
  collegeData: selector.getCampuDetails(state),
  notificationData: selector1?.getNotificationData(state),
  studentData: selector.getStudentResumeData(state),
  studentDetails: selector.getStudentDetails(state),
})

const mapDispatchToProps = {
  signOut,
  getNotificationsList,
  markNotificationReadApi,
  getUserPermissions,
  updateStudent,
  registerEvent,
  getEventsList,
  ApplyRole
}

export default connect(mapStateToProps, mapDispatchToProps)(Page)
